import { render, staticRenderFns } from "./EventsFollowFacebookPixelTable.vue?vue&type=template&id=47c03592&"
import script from "./EventsFollowFacebookPixelTable.vue?vue&type=script&lang=ts&"
export * from "./EventsFollowFacebookPixelTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
